var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event",class:{
    'event-purple': _vm.colorScheme === 'purple',
    'event-green': _vm.colorScheme === 'green',
    'event-blue': _vm.colorScheme === 'blue',
  }},[_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"image",attrs:{"src":_vm.urlFor(_vm.event.image).width(120).height(120).url(),"alt":"event bilde"}})]),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.event.title))]),(!!_vm.event.dateExactFormatted)?_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.event.dateExactFormatted))]):_vm._e(),(!!_vm.event.dateDescription)?_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.event.dateDescription))]):_vm._e(),_c('p',{staticClass:"tags"},[_c('span',{staticClass:"tag",class:{
        'tag-purple': _vm.colorScheme === 'purple',
        'tag-green': _vm.colorScheme === 'green',
        'tag-blue': _vm.colorScheme === 'blue',
    }},[_vm._v(" "+_vm._s(_vm.event.type.name)+" ")]),_c('span',{staticClass:"tag",class:{
        'tag-purple': _vm.colorScheme === 'purple',
        'tag-green': _vm.colorScheme === 'green',
        'tag-blue': _vm.colorScheme === 'blue',
    }},[_vm._v(" "+_vm._s(_vm.event.role.name)+" ")]),_c('span',{staticClass:"tag",class:{
        'tag-purple': _vm.colorScheme === 'purple',
        'tag-green': _vm.colorScheme === 'green',
        'tag-blue': _vm.colorScheme === 'blue',
      }},[_vm._v(" "+_vm._s(_vm.event.location)+" ")])]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.event.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }